<template>
    <div class="main" style="padding-bottom:50px">

        <div id="printMe" style="margin-top:50px;background:#fff; padding:30px;">
            <div class="container">
                <!-- Content here -->
                <div>
                    <div>
                        <div style="color:#000000;width: 100%; font-size: 20px; height: auto;margin-top:5px;">
                            Statement
                            of Account</div>
                    </div>
                    <div class="">
                        <span style="font-size:16px; font-weight:bolder">20-09-2024</span>
                    </div>

                </div>

                <div class="row" style="margin-top:30px;">
                    <div class="col" :span="16">
                        <div style="font-weight:bolder">To Cowtribe</div>
                        <!-- <div style="padding-left: 38px;padding-right: 38px;">Air</div> -->
                    </div>

                    <div class="col" :span="8" style="display: flex; justify-content: end; flex-direction: column;">
                        <div class="row"
                            style="font-weight:bolder;height: 26px;padding-left: 20px; border-radius: 14px;background-color: #26A246; color: #fff; font-size: 15px;">
                            <p class="col">Account Summary</p>
                        </div>
                        <div class="row mt-3" style="padding-left: 20px;">
                            <p class="col">Opening Balance</p>
                            <p class="col" style="color: #3E3E3E">Ksh 2,000</p>
                        </div>
                        <div class="row" style="padding-left: 20px;">
                            <p class="col">Invoiced Amount</p>
                            <p class="col" style="color: #3E3E3E">Ksh 2,000</p>
                        </div>
                        <div class="row" style="padding-left: 20px;">
                            <p class="col">Amount Received</p>
                            <p class="col" style="color: #3E3E3E">Ksh 2,000</p>
                        </div>
                        <div class="row mt-2"
                            style="font-weight:bolder;height: 26px;padding-left: 20px; border-radius: 14px;background-color: #D9D9D9; color: #4C4C4C; font-size: 15px;">
                            <p class="col">Balance Due</p>
                            <p class="col" style="color: #3E3E3E">Ksh 2,000</p>
                        </div>
                    </div>
                </div>
                <div style="margin-top:50px">
                    <table class="table table-hover">
                        <thead style="background-color: #26A246; color: #fff;">
                            <tr>
                                <th scope="col">Date</th>
                                <th scope="col">Transaction</th>
                                <th scope="col">Details</th>
                                <th scope="col">Amount</th>
                                <th scope="col">Payment</th>
                                <th scope="col">Balance</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="product in tableData" :key="product.id">
                                <td>{{ product.date }}</td>
                                <td>{{ product.txn }}</td>
                                <td>{{ product.details }}</td>
                                <td>{{ product.amount }}</td>
                                <td>{{ product.payment }}</td>
                                <td>{{ product.balance }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

const columns = [
    {
        title: 'Product Name',
        dataIndex: 'name',
        key: "name",
        // scopedSlots: { customRender: 'name' },
        width: 200,
    },
    // {
    //     title: 'Category',
    //     dataIndex: 'category',
    //     // scopedSlots: { customRender: 'category' },
    //     key:"category",
    // 	width: 200,
    // },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: "quantity",
        // scopedSlots: { customRender: 'quantity' },
        // width: 200,
    },
    {
        title: 'Selling Price',
        dataIndex: 'unitPrice',
        key: "unitPrice",
        // scopedSlots: { customRender: 'unitPrice' },
        // width: 200,
    },
    {
        title: 'Line Total',
        dataIndex: 'lineTotal',
        key: "lineTotal"
        // width: 200,
    },

]



const tableData = [
    {
        id:1,
        key:1,
        date: "02-05-2024",
        txn: "Opening Balance",
        details: "Ksh 1,000 in excess payment",
        amount: "Ksh 1000",
        payment: "Ksh, 1000",
        balance: "Ksh 1000"
    },
    {   
        id:2,
        key:2,
        date: "02-05-2024",
        txn: "Opening Balance",
        details: "Ksh 1,000 in excess payment",
        amount: "Ksh 1000",
        payment: "Ksh, 1000",
        balance: "Ksh 1000"
    },
    {
        id:3,
        key:3,
        date: "02-05-2024",
        txn: "Opening Balance",
        details: "Ksh 1,000 in excess payment",
        amount: "Ksh 1000",
        payment: "Ksh, 1000",
        balance: "Ksh 1000"
    }
]

export default {
    name: "StatementReport",
    components: {},
    data() {
        return {
            columns,
            tableData,
            tableLoading: false,
            loading: false,
            addProductVisible: false,
            discount: 0,
            deliveryDate: null,
            supplierId: "",
            supplierName: "",
            supplierAddress: "",
            supplierCity: "",
            supplierCountry: "",
            destionation: "",
            destionationName: "",
            sellerAddress: "",
            shipCity: "",
            statusLabel: "",
            shipCountry: "",
            shippingMethod: "0",
            shippinTerm: "",
            purchaseOrderId: "",
            deliveriestableData: [],
            pagination: {
                pageSize: 20
            },
        };
    },
    computed: {
        ...mapGetters(['getPreViewInfo']),
        displayTotalAmount() {
            // console.log("in tableData |", this.tableData)
            const itemAmount = this.tableData.map(item => {
                if (item.unitPrice && item.quantity) {
                    return parseFloat(item.unitPrice) * item.quantity
                } else {
                    return 0
                }
            })
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return parseFloat(totalAmt)

        },
        getPurchaseOrderIder() {
            return this.purchaseOrderId ? `Order #PO-${this.purchaseOrderId}` : ""
        },
        currentDate() {
            return moment().format("DD-MMM-YYYY")
        },

        displayGrandTotal() {
            return (this.displayTotalAmount - this.discount)
        }
    },
    methods: {
        ...mapActions(['setPreviewInfo', 'generatePurcharseOrder', 'setWareHouseDeliveryLinesInfo']),
        redirectPreviousUrl() {
            this.$router.back()
            // this.$router.push('/purchase-order-history').catch(()=>{});
        },
        handleAddProductCancel() {
            this.addProductVisible = false
        },
        downloadReceipt() {

            this.addProductVisible = true
            // this.$htmlToPaper('printMe');
        },
        editPurchaseOrder() {
            this.$router.push('/purchase-order-edit').catch(() => { });
        },
        showEditActions(statusLabel) {
            const allowedStatus = ['Draft']
            const result = allowedStatus.includes(statusLabel) ? true : false
            return result
        },
        showEmailActions(statusLabel) {
            const allowedStatus = ['Draft']
            const result = allowedStatus.includes(statusLabel) ? true : false
            return result
        },

        showDeliveryLines(data) {
            this.setWareHouseDeliveryLinesInfo(data)
            this.$router.push({
                name: 'warehouse-details-lines',
                params: { locationId: data.id }
            }).catch(() => { })
        },

        submitReceipt() {
            this.$htmlToPaper('printMe');
        },
    },
    created() {}
}
</script>

<style scoped>
.editable-cell {
    position: relative;
}

.editable-cell-input-wrapper,
.editable-cell-text-wrapper {
    padding-right: 24px;
}

.editable-cell-text-wrapper {
    padding: 5px 24px 5px 5px;
}

.editable-cell-icon,
.editable-cell-icon-check {
    position: absolute;
    right: 0;
    width: 20px;
    cursor: pointer;
}

.editable-cell-icon {
    line-height: 18px;
    display: none;
}

.editable-cell-icon-check {
    line-height: 28px;
}

.editable-cell:hover .editable-cell-icon {
    display: inline-block;
}

.editable-cell-icon:hover,
.editable-cell-icon-check:hover {
    color: #108ee9;
}

.editable-add-btn {
    margin-bottom: 8px;
}

a {
    text-decoration: none;
}

@media print {
    @page {
        size: landscape
    }
}
</style>